<start-page *ngIf="tabIndex == 0" (changeTab)="onTabChange($event)"></start-page>
<pre-engagement *ngIf="tabIndex == 1" (changeTab)="onTabChange($event)"></pre-engagement>
<passage *ngIf="tabIndex == 2" (changeTab)="onTabChange($event)" ></passage>
<post-engagement *ngIf="tabIndex == 3" (changeTab)="onTabChange($event)"></post-engagement>
<final-review *ngIf="tabIndex == 4" (changeTab)="onTabChange($event)"></final-review>
<engagement-review *ngIf="tabIndex == 5" (changeTab)="onTabChange($event)"></engagement-review>
